<template>
    <div id="TEST-MODAL-PRIVACY-POLICY-AGREEMENT" class="m-modal c-modal-privacy-policy-agreement"
         data-jest="modal-privacy-policy-agreement">
        <div class="m-modal-box">
            <div class="l-element m-modal-body is-mgt8 is-mgb8">
                <div class="m-modal-content">
                    <div v-if="canDisplayContents">
                        <div class="l-element m-heading-large is-text-center is-text-bold is-black is-mgb16">
                            プライバシーポリシーを<br>ご確認ください
                        </div>
                        <div class="l-element is-text-center">
                            <form-checkbox name="checked-privacy-policy" v-model="isChecked">
                                <a target="_blank" href="/web/common/information/appliPolicy">プライバシーポリシー</a>を確認しました
                            </form-checkbox>
                        </div>
                        <div class="l-element">
                            <p v-if="isSendError" class="m-text-comments is-caution is-mgb8" data-jest="error-text">通信に失敗しました。もう一度「同意して利用する」ボタンを押してください。</p>
                            <btn id="TEST-MODAL-PRIVACY-POLICY-AGREEMENT-BTN" @click="setAgreement" :priority="agreeButtonPriority" text="同意して利用する" data-jest="agree-button"/>
                        </div>
                    </div>
                    <!--プラポリ同意状況取得失敗時-->
                    <div v-else>
                        <error-read-contents ga-event-label="PRIVACY_POLICY_AGREEMENT_MODAL_ERROR"
                                             data-jest="modal-privacy-policy-agreement-error"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Btn from "../atoms/Btn.vue";
import ErrorReadContents from "../molecules/ErrorReadContents.vue";
import {cssPriority} from "../../view-model/enum/CSSPriority";
import {getGa4EventLabel} from "../../util/Ga4EventUtil.js";
import {setNotScrollBackground} from "../../util/modalUtil.js";
import PrivacyPolicyStatusesViewModel from "../../view-model/PrivacyPolicyStatusesViewModel"
import {setPrivacyPolicyAgreement} from "../../model/action/PrivacyPolicyAgreementAction";
import FormCheckbox from "../atoms/FormCheckbox.vue";

export default {
    name: "ModalPrivacyPolicyAgreement",
    components: {
        FormCheckbox, ErrorReadContents, Btn
    },
    props: {
        /**
         * プライバシーポリシー同意状況
         */
        privacyPolicyStatuses: {
            type: PrivacyPolicyStatusesViewModel,
            required: true
        }
    },
    emits: ['close'],
    data() {
        return {
            cssPriority: cssPriority,
            isChecked: false,
            isSendRunning: false,
            isSendError: false,
        }
    },
    created() {
        setNotScrollBackground()
    },
    mounted() {
        if(this.canDisplayContents) {
            getGa4EventLabel('SHOW_MODAL', 'PRIVACY_POLICY_AGREEMENT_MODAL')
        } else {
            getGa4EventLabel('SHOW_MODAL', 'PRIVACY_POLICY_AGREEMENT_MODAL_ERROR')
        }
    },
    computed: {
        agreeButtonPriority() {
            if(!this.isChecked || this.isSendRunning) {
                return cssPriority.DISABLED
            } else {
                return cssPriority.PRIMARY
            }
        },
        canDisplayContents() {
            return this.privacyPolicyStatuses && this.privacyPolicyStatuses.servicePolicy && this.privacyPolicyStatuses.specialContract
        }
    },
    methods: {
        emit(emitName) {
            this.$emit(emitName);
        },
        setAgreement() {
            if (!this.isChecked || this.isSendRunning) {
                return;
            }
            this.isSendRunning = true;
            setPrivacyPolicyAgreement(this.privacyPolicyStatuses)
                .then(() => {
                    getGa4EventLabel('FORM_BUTTON', 'PRIVACY_POLICY_AGREEMENT_MODAL')
                    document.querySelector('body').style.overflow = 'visible';
                    document.querySelector('body').style.position = 'static';
                    document.querySelector('body').style.width = 'auto';
                    this.emit('close');
                })
                .catch(() => {
                    getGa4EventLabel('FORM_BUTTON', 'PRIVACY_POLICY_AGREEMENT_MODAL_ERROR')
                    this.isSendError = true;
                    this.isSendRunning = false;
                })
        }
    }

}
</script>

<style lang="scss" scoped>
.c-modal-privacy-policy-agreement {
    a {
        text-decoration: underline;
    }
    :deep(.m-form-checkbox) {
        display: inline-block;
    }
}
</style>
